import { createRequestActions, createFetchAction } from '../utils';
import * as shadeTypes from './shadeTypes';

export const fetchShades = createFetchAction(shadeTypes.FETCH_SHADES, 'shadeId');
export const saveShade = createRequestActions(shadeTypes.SAVE_SHADE);
export const updateInci = createFetchAction(shadeTypes.UPDATE_INCI, 'shadeId');
export const deleteShade = createFetchAction(shadeTypes.DELETE_SHADE, 'shadeId');
